export const spacesList = [
    {
        id: "uniswap",
        name: 'Uniswap',
    },
    {
        id: "sushigov.eth",
        name: 'Sushi',
    },
    {
        id: "hop.eth",
        name: "Hop Exchange"
    },
    {
        id: "gnosis.eth",
        name: "GnosisDAO"
    },
    {
        id: "1inch.eth",
        name: "1inch Network"
    },
    {
        id: "gitcoindao.eth",
        name: "Gitcoin"
    },
    {
        id: "ens.eth",
        name: "ENS"
    },
    {
        id: "aave.eth",
        name: "AAVE"
    },
    {
        id: "stgdao.eth",
        name: "Stargate DAO"
    },
    {
        id: "arbitrum-odyssey.eth",
        name: "Arbitrum Odyssey"
    },
    {
        id: "opcollective.eth",
        name: "Optimism Collective"
    },
    {
        id: "curve.eth",
        name: "Curve Finance"
    },
    {
        id: "shellprotocol.eth",
        name: "Shell Protocol"
    },
    {
        id: "dydxgov.eth",
        name: "dYdX"
    },
    {
        id: "balancer.eth",
        name: "Balancer"
    },
    {
        id: "sismo.eth",
        name: "Sismo"
    },
    {
        id: "layer2dao.org",
        name: "Layer2 DAO"
    },
    {
        id:"lido-snapshot.eth",
        name:"Lido"
    },
    {
        id:"mail3.eth",
        name:"Mail3"
    },
];
